export const SET_PAGE_STATE = "SET_PAGE_STATE";
export const DELETE_PAGE_STATE = "DELETE_PAGE_STATE";
